import { useGqlMutation, useGqlQuery } from '@API/useAvQuery';
import { QueryKey } from '@fabric-ui/utils';
import { gql } from 'graphql-request';
import { GetRiskScoringConfigResponse } from './types';

export const useGetRiskScoringConfig = ({ projectionName }: { projectionName: string }) =>
  useGqlQuery<GetRiskScoringConfigResponse>({
    queryKey: [QueryKey.GetRiskScoringConfig, projectionName],
    query: GET_RISK_SCORING_CONFIG,
    variables: { projectionName },
  });

export const useGetAllRiskScoringConfig = () =>
  useGqlQuery<GetRiskScoringConfigResponse>({
    queryKey: [QueryKey.GetAllRiskScoringConfig],
    query: GET_ALL_RISK_SCORING_CONFIG,
  });

export const useCreateOrUpdateRiskScoringConfig = () =>
  useGqlMutation({
    mutationKey: [QueryKey.CreateOrUpdateRiskScoringConfig],
    mutation: CREATE_OR_UPDATE_RISK_SCORE,
  });

const GET_ALL_RISK_SCORING_CONFIG = gql`
  query getAllRiskScoringConfig {
    getAllRiskScoringConfig {
      projectionToRiskScores {
        projectionName
        riskScore {
          id
          accountId
          projectionName
          config {
            baseScoreWeightContribution {
              projectionName
              weight
              aggType
            }
          }
        }
      }
      projectionToBaseScores {
        projectionName
        baseScore {
          id
          accountId
          projectionName
          config {
            configTypes {
              type
              factorGroups {
                name
                weight
                factors {
                  fieldName
                  fallback
                  scoringRules {
                    value
                    filter
                    adjustmentType
                  }
                }
              }
            }
          }
        }
      }
      riskScoreProjectionToBaseScoresMap {
        riskScoreProjectionName
        baseScores {
          projectionName
          allowedAggTypes
        }
      }
    }
  }
`;

const CREATE_OR_UPDATE_RISK_SCORE = gql`
  mutation createOrUpdateRiskScoringConfig($input: RiskScoringCreationRequestInput!) {
    createOrUpdateRiskScoringConfig(input: $input)
  }
`;

const GET_RISK_SCORING_CONFIG = gql`
  query getRiskScoringConfig($projectionName: String!) {
    getRiskScoringConfig(projectionName: $projectionName) {
      projectionToRiskScores {
        projectionName
        riskScore {
          id
          accountId
          projectionName
          config {
            baseScoreWeightContribution {
              projectionName
              weight
              aggType
            }
          }
        }
      }
      projectionToBaseScores {
        projectionName
        baseScore {
          id
          accountId
          projectionName
          config {
            configTypes {
              type
              factorGroups {
                name
                weight
                factors {
                  fieldName
                  fallback
                  scoringRules {
                    value
                    filter
                    adjustmentType
                  }
                }
              }
            }
          }
        }
      }
      riskScoreProjectionToBaseScoresMap {
        riskScoreProjectionName
        baseScores {
          projectionName
          allowedAggTypes
        }
      }
    }
  }
`;
